import React from 'react';


/**
 * TODO:
 * - replace Google Maps API Key for Olympia's corporate one
 * - fix marker positioning, add price
 */
class ResultCardMap extends React.Component {

    render() {
        const { center, width, height } = this.props;
        const w = width || 640;
        const h = height || 480;
        const key = 'AIzaSyAL_CRxPjp3ZKv6oR0ywND_WAChT_7fwvY';

        const paths = ['https://maps.googleapis.com/maps/api/staticmap?'];
        paths.push('center=' + center.lat + ',' + center.lng);
        paths.push('zoom=16');
        paths.push('size=' + w + 'x' + h);
        paths.push('markers=label:H%7C' + center.lat + ',' + center.lng);
        paths.push('key=' + key);
        const url = paths.join('&');
        const link = 'http://maps.google.com/maps?q=' + center.lat + ',' + center.lng;

        return (
            <a href={link} alt="Abrir mapa" rel="noopener noreferrer" target="_blank">
                <img alt="hotel location" width={w} height={h}
                    src={url} />
            </a>
        );
    }
}

export default ResultCardMap;



// WEBPACK FOOTER //
// ./src/components/Results/ResultCardMap.js